import {Component, input, ChangeDetectionStrategy} from "@angular/core"
import {AttachmentsItemType, AttachmentsComponent} from "@common/components/files/attachments/attachments.component"
import {SectionComponent} from "@common/components/item"
import {DataObjectAssignmentType} from "@generated"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-files-section",
    imports: [SectionComponent, AttachmentsComponent],
    templateUrl: "./files-section.component.html",
    styleUrl: "./files-section.component.scss",
})
export class FilesSectionComponent {
    readonly $item = input<AttachmentsItemType | null | undefined>(null, {alias: "item"})
    readonly $assignmentTypes = input<DataObjectAssignmentType[]>([DataObjectAssignmentType.Attachment, DataObjectAssignmentType.GalleryImage], {
        alias: "assignmentTypes",
    })
    readonly $canDownload = input<boolean>(true, {alias: "canDownload"})
}
